import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { ResourceService } from '../resource.service';
import { Preferences } from './preferences';
import { PreferencesSerializer } from './preferences.serializer';

@Injectable()
export class PreferencesService extends ResourceService<Preferences> {
  baseUrl = environment.serverUrl + 'preferences/';

  constructor(http: HttpClient) {
    super(http, 'preferences/', new PreferencesSerializer());
  }

  listStatic(token: string): Observable<Preferences[]> {
    const ticketUrl = this.baseUrl;

    let headers = new HttpHeaders();
    headers = headers.append('Accept', 'application/json');
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Authorization', 'Token ' + token);

    return this.http.get(ticketUrl, { headers }).pipe(
      map(res => this.captureMetaData(res)),
      map(data => this.convertData(data)),
      catchError((res: Response) => this.handleError(res))
    );
  }
}
